import { useDispatch } from 'react-redux';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';

import OpenChat from '~/src/components/OpenChatLink';
import { pushDataLayer } from '~/src/features/payments-abn/components/SeasonTicketPayment/helpers';
import { setTicketPopup } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { paySeasonTicket } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actions';
import { initialTicketPopupState } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/reducer';

import * as ST from './styled';

const PaymentDeclined = (): JSX.Element => {
    const dispatch = useDispatch();

    const onTryAgain = () => {
        pushDataLayer('subscription_connect_try_again');
        dispatch(paySeasonTicket());
        dispatch(setTicketPopup(initialTicketPopupState));
    };

    return (
        <ST.UpShiftedContent>
            <ST.Text>
                Попробуйте пополнить баланс ещё раз или обратитесь в&nbsp;<OpenChat><ST.ChatLink>поддержку</ST.ChatLink></OpenChat>.
                Абонемент заработает, когда на балансе будет достаточно денег.
            </ST.Text>
            <ButtonGroup>
                <Button
                    size={'large'}
                    bType={'action'}
                    onClick={onTryAgain}
                >
                    Попробовать снова
                </Button>
            </ButtonGroup>
        </ST.UpShiftedContent>
    );
};

export default PaymentDeclined;
